module.exports = __webpack_public_path__ + "img/455.f9dbbf50.jpg";